var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCarCrashAlternative = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#carCrashAlternative_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "carCrashAlternative_svg__b",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 28,
  height: 24
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M28 0H0v24h28V0Z",
  fill: "#fff"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#carCrashAlternative_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.916 8c.77 0 1.423.42 1.656 1.01L28 15v8c0 .55-.525 1-1.167 1h-1.166c-.642 0-1.167-.45-1.167-1v-1h-14v1c0 .55-.525 1-1.167 1H8.166c-.641 0-1.167-.45-1.167-1v-8l2.427-5.99C9.67 8.42 10.312 8 11.082 8h12.834ZM9.332 20h16.334v-5H9.332v5Zm2.917-4c.966 0 1.75.671 1.75 1.5 0 .828-.784 1.5-1.75 1.5s-1.75-.672-1.75-1.5c0-.829.784-1.5 1.75-1.5Zm10.5 0c.966 0 1.75.671 1.75 1.5 0 .828-.784 1.5-1.75 1.5s-1.75-.672-1.75-1.5c0-.829.784-1.5 1.75-1.5Zm-12.518-2.89h14.525L23.496 10H11.49l-1.26 3.11Zm-4.352-2.145v1.995c-.048 0-5.75-.05-5.865.006V10.96l5.865.006Zm3.127-4.66L7.356 7.72 3.23 4.184l1.65-1.414 4.125 3.535ZM15.127.012c-.066.1-.008 4.993-.008 5.028h-2.327l.009-5.028h2.326Z",
  fill: "#447948"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "carCrashAlternative_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h28v24H0z"
})))));
export default SvgCarCrashAlternative;